import React from "react";
import { useTranslation } from "react-i18next";
import ActionButtonStyle from "styles/application/ActionButtonStyle";

// Init styled components
const AAD = ActionButtonStyle();

const ActionButtons = ({ handleAddDialogOpen, disabled }) => {
	const { t } = useTranslation();
	return (
		<AAD.ButtonContainer>
			<AAD.GeneralButton
				disableElevation
				variant="contained"
				disabled={disabled}
				onClick={handleAddDialogOpen}
			>
				{t("action.addNew")}
			</AAD.GeneralButton>
		</AAD.ButtonContainer>
	);
};

export default ActionButtons;
